module.exports = __webpack_public_path__ + "img/header-weddingRingsHearts@2x.ef1d9b1.jpg";